import styled from "styled-components";
import { useTranslation } from "react-i18next";

const SupportCenterContainer = styled.div`
  height: 198px;
  background: rgb(255, 255, 255);
  box-shadow: rgb(0 0 0 / 5%) 0px -1px 2px, rgb(0 0 0 / 10%) 0px 2px 4px;
  border-radius: 6px 24px;
`;

const Title = styled.div`
  ont-family: KBFGDisplay;
  font-weight: bold;
  font-size: 16px;
  line-height: 24px;
  text-align: center;
  color: rgb(94, 81, 77);
`;

const Image = styled.img`
  ont-family: KBFGDisplay;
  font-weight: bold;
  font-size: 16px;
  line-height: 24px;
  text-align: center;
  color: rgb(94, 81, 77);
`;

const Info = styled.div`
  font-family: KBFGDisplay;
  font-weight: bold;
  font-size: 24px;
  line-height: 24px;
  text-align: center;
  color: rgb(94, 81, 77);
`;

const SupportCenterBox = function (props) {
  const { t } = useTranslation();

  return (
    <SupportCenterContainer className='d-flex flex-column align-items-center justify-content-center position-relative'>
      <div className='position-absolute top-0 end-0'>
        <svg
          width='111'
          height='75'
          viewBox='0 0 111 75'
          fill='none'
          xmlns='http://www.w3.org/2000/svg'
        >
          <g clipPath='url(#clip0_4948_9416)'>
            <rect
              width='101.167'
              height='101.167'
              rx='12'
              transform='matrix(0.692765 -0.721163 0.692765 0.721163 56.0842 21.9815)'
              fill='#F2A900'
              fillOpacity='0.05'
            ></rect>
            <rect
              width='101.167'
              height='101.167'
              rx='12'
              transform='matrix(0.692765 -0.721163 0.692765 0.721163 0 2.05966)'
              fill='#F2A900'
              fillOpacity='0.05'
            ></rect>
          </g>
          <defs>
            <clipPath id='clip0_4948_9416'>
              <path
                d='M0 0H87C100.255 0 111 10.7452 111 24V75H0V0Z'
                fill='white'
              ></path>
            </clipPath>
          </defs>
        </svg>
      </div>
      <Title>{props.title}</Title>
      <Image src={props.image} width={100} />
      <Info>{props.info}</Info>
    </SupportCenterContainer>
  );
};

export default SupportCenterBox;
